import { http } from '@/core/api';
import { listCompaniesUrl } from '@/config/config';
import { mapCompaniesApiToVm } from './users.mapper';

export const getCompanies = () =>
  http
    .get(listCompaniesUrl)
    .then(response => mapCompaniesApiToVm(response.data.companies))
    .catch(error => console.error(error));
